<template>
  <div class="edit-charge-rule">
    <van-form class="form">
      <van-field readonly clickable label="可计费数量" input-align="right">
        <template #input>{{ amount }}天</template>
      </van-field>
      <div class="gray">
        <span>购买数量：{{buyAmount}}天</span> <span style="margin-left:20px;">已退转结：{{refundTransferAmount}}天</span>
      </div>
      <van-cell
        title="开始计费日期"
        title-class="tctil"
        :is-link="!startDate"
        @click="selectDate"
        :border="!isEarly"
      >
        <template>
          <div v-if="startDate" class="date-wrapper">
            <div>
              <div class="vu van-ellipsis">
                开始日期：{{ startDate | formatDatetime('yyyy-MM-dd') }}
              </div>
              <div class="desc van-ellipsis">
                结束日期：{{ endDate | formatDatetime('yyyy-MM-dd') }}
              </div>
            </div>
            <van-icon class="icon" name="clear" @click.stop="clearDate" />
          </div>
          <div v-else>选择计费日期</div>
        </template>
      </van-cell>
      <div class="tip van-hairline--bottom" v-if="isEarly">
        开始计费日期早于今天，系统将自动扣除今天前的按天课消金额
      </div>
      <van-field
        type="textarea"
        v-model="remark"
        autosize
        input-align="left"
        rows="3"
        maxlength="500"
        placeholder="请输入备注信息"
        show-word-limit
      />
    </van-form>
    <pageFooterBtn btnText="保存" :loading="submiting" loading-text="提交中..." @click="submit" />
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

export default {
  computed: {
    isEarly() {
      if (this.startDate == '') {
        return false;
      }
      const startDate = new Date(this.startDate);
      let today = app.tool.date.formatDatetime(new Date(), 'yyyy-MM-dd');
      today = new Date(`${today} 00:00:00`);
      return startDate.getTime() < today.getTime();
    },
  },
  data() {
    return {
      pageTitle: '编辑计费时段',
      submiting: false,
      startDate: '',
      endDate: '',
      orderId: '',
      orderItemId: '',
      remark: '',
      amount: '',
      buyAmount: '',
      refundTransferAmount: '',
    };
  },
  methods: {
    clearDate() {
      this.startDate = '';
      this.endDate = '';
    },
    // 选择有效期
    async selectDate() {
      let res = await app.x3.picker.calendar({
        defaultDate: this.startDate || new Date(),
        minDate: new Date(2020, 0, 1),
        maxDate: new Date(2030, 12, 31),
      });
      this.startDate = res;
      this.endDate = new Date(res.getFullYear(), res.getMonth(), res.getDate() + Number(this.amount) - 1);
    },
    submit() {
      this.submiting = true;
      this.showLoading();
      this.$api
        .editChargeRule({
          orderId: this.orderId,
          orderItemId: this.orderItemId,
          startTime: app.tool.date.formatDatetime(this.startDate, 'yyyy-MM-dd'),
          endTime: app.tool.date.formatDatetime(this.endDate, 'yyyy-MM-dd'),
          remark: this.remark,
        })
        .then(res => {
          this.$toast.clear();
          this.submiting = false;
          if (res.code === 200) {
            app.vue.$emit('refresh-student-school-record-list');
            app.vue.$emit('refresh-class-card-detail');
            this.$toast.success('保存成功');
            this.$router.back();
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .catch(err => {
          console.log('保存有效期出错：', err);
          this.submiting = false;
        });
    },
  },
  filters: {
    filterDate(v) {
      return v && new Date(v) ? app.tool.date.filterDate(new Date(v)) : '请选择';
    },
  },
  async created() {
    const chargeId = +this.$vxRoute.query.chargeId;
    const res = await this.$api.findChargeRecordOrder({
      chargeId: chargeId
    });
    this.orderId = res.data.orderId;
    this.orderItemId = res.data.orderItemId;
    this.buyAmount = res.data.buyAmount;
    this.refundTransferAmount = res.data.refundTransferAmount;
    this.amount = this.buyAmount - this.refundTransferAmount;
    if (res.data.chargeRules[0] && res.data.chargeRules[0].chargeStartTime) {
      this.startDate = new Date(res.data.chargeRules[0].chargeStartTime);
    } else {
      this.startDate = '';
    }
    if (res.data.chargeRules[0] && res.data.chargeRules[0].chargeEndTime) {
      this.endDate = new Date(res.data.chargeRules[0].chargeEndTime);
    } else {
      this.endDate = '';
    }   
  },
  components: {
    pageFooterBtn,
  },
};
</script>

<style lang="scss" scoped>
.edit-charge-rule {
  display: flex;
  flex-direction: column;
  height: 100%;
  .form {
    flex: 1;
  }
  .date-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .icon {
      padding: 6px 4px;
    }
  }

  .gray {
    background: var(--g1);
    color: var(--g6);
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    padding: 8px 16px 20px;
  }
  .van-cell {
    .tctil {
      color: var(--g7);
      padding-right: 10px;
    }
    .van-cell__value {
      color: var(--g5);
    }

    .vu {
      color: var(--g8);
    }
  }
  .tip {
    padding: 0 16px;
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    background: var(--white);

    color: var(--c3);
  }
}
</style>